import React from 'react';
import CustomInput from "./customInput";
import configData from "../config.json";

export default function ConfirmPage(props) {

    const folderPath = configData.IMAGE_URL + "event/";


    return (
        <div>
            <div className="border-bottom pb-3 mb-3 mt-3">
                <h5>Confirmation / 確認</h5>
                <p>
                        Here is the confirmed information of your selected model name, size, pick-up location and your information. 
                        Please check and click "submit" to proceed to ballot registration. 
                        Please ensure the information provided is correct and the relevant information cannot be modified once submitted. 
                        Sportshouse does not having any liabilities if we could not contact or verify the identity of the participants in the event that the provision of incorrect or false information was being provided by the participants.
                </p>
                <p>
                    參加者請再次確認填寫之資料，包括鞋款型號、尺碼、自取地址及個人資料。
                    如資料無誤，請按"提交"。
                    參加者所填寫的資料必須正確無誤，有關資料一經遞交便不能作任何修改。
                    本公司不會就參加者所提供的資料錯誤而引致無法通知參加者或核對參加者身份而負上任何責任。
                </p>
                <CustomInput
                    name1="Full name in Chinese (must be same as HKID/Passport)"
                    name2="中文姓名 (需與身分證/護照上的姓名完全相同)"
                    disabled={true}
                    value={props.form.name}/>

                <CustomInput
                    name1="Full name in English (must be same as HKID/Passport)"
                    name2="英文姓名 (需與身分證/護照上的姓名完全相同)"
                    disabled={true}
                    value={props.form.enName} />

                <CustomInput
                    name1="HKID Card / Passport No. (First 5 digits A1234)"
                    name2="身份證明文件號碼 (頭5位字元包括英文字母)"
                    disabled={true}
                    value={props.form.hkid} />

                <CustomInput
                    name1="Hong Kong Mobile Phone No."
                    name2="香港手提電話號碼"
                    disabled={true}
                    value={props.form.phone} />

                <CustomInput
                    name1="Email address"
                    name2="電郵地址"
                    disabled={true}
                    value={props.form.email} />

					{
						props.socialMedia && <CustomInput
						name1="Social Media Account"
						name2="社交平台帳號"
						disabled={true}
						value={props.form.socialMedia} />
					}
            </div>
            <div className="border-bottom pb-3 mb-3 mt-3">
                <h5>Registration Summary</h5>
                <div className="table-responsive-sm">
                <table className="table">
                    <thead>
                        <tr style={{ 'backgroundColor': 'green', 'color': 'white' }}>
                            <th style={{ 'width': '40%' }} scope="col">ITEM</th>
                                <th style={{ 'width': '60%' }} scope="col">DETAIL</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            props.form.items.map(item => {
                                var locationDetails = props.locations.find(i => i.code === item.loc);
                                var sizingSystem = props.items.find(i => i.styleNo === item.styleNo).sizingSystem;
                                return (
                                    <tr key={"confirmTable_" + item.styleNo}>
                                        <td>
                                            <img alt={item.styleNo} style={{ 'width': '100%' }} src={folderPath + props.eventCode + "/" + item.styleNo + "_image.jpg"} />
                                        </td>
                                        <td>
                                            <p>
                                                <span className="text-success">Size / 尺碼 ({sizingSystem})</span><br/>
                                                {item.size}
                                            </p>
                                            <p>
                                                <span className="text-success">Pick-up Location / 取貨店鋪</span><br />
                                                {locationDetails.addressEn} <br />
                                                {locationDetails.addressChi}
                                            </p>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
